<script>
  import { getEmulateUsers } from 'services/api/apiCalls'
  import Svelecte, { addRenderer } from 'svelecte'
  import { onMount, tick } from 'svelte'
  import { emulateUser } from 'stores/auth'
  import Loader from 'shared/feedback/Loader/Loader.svelte'
  import { clearSavedStorage } from 'utils/localstorage'

  // Svelecte configuration
  const fetchDebounceTime = 1000
  const inputMaxLength = 100

  // Custom renderer for the Svelecte component
  function userRender(item) {
    return `<div > ${item?.firstName} ${item?.lastName} (${item?.email})</div>`
  }

  addRenderer('user-render', userRender)

  let selectedEmulateUser = $state(null)
  let isLoading = $state(false)
  let emulateOptions = $state([])
  let svelecteWrapper
  let searchTimeoutId = null
  let activeSearchRequest = 0

  function configureSvelecteInput() {
    const svelecteInput = svelecteWrapper?.querySelector('input')
    if (!svelecteInput) {
      return
    }

    // Keep legacy automation selectors stable after the Svelecte upgrade.
    svelecteInput.classList.add('sv-content')
    svelecteInput.setAttribute('maxlength', String(inputMaxLength))
    svelecteInput.focus()
  }

  async function searchEmulateUsers(query) {
    const requestId = ++activeSearchRequest

    try {
      const users = await getEmulateUsers(query)
      if (requestId === activeSearchRequest) {
        emulateOptions = users
      }
    } catch {
      if (requestId === activeSearchRequest) {
        emulateOptions = []
      }
    }
  }

  function scheduleSearch(query) {
    const normalizedQuery = query.trim()

    clearTimeout(searchTimeoutId)
    activeSearchRequest += 1

    if (!normalizedQuery) {
      emulateOptions = []
      return
    }

    searchTimeoutId = setTimeout(() => {
      searchEmulateUsers(normalizedQuery)
    }, fetchDebounceTime)
  }

  function handleSvelecteInput(event) {
    if (event.target instanceof HTMLInputElement) {
      scheduleSearch(event.target.value)
    }
  }

  onMount(() => {
    tick().then(() => {
      configureSvelecteInput()
    })

    return () => {
      clearTimeout(searchTimeoutId)
    }
  })

  const emulateAction = async () => {
    clearSavedStorage(['tutorial-dismissed', 'gridFilters'])
    emulateUser.set(selectedEmulateUser)
    isLoading = true
    window.location.reload()
  }
</script>

<style>
  .drawer-content {
    padding: 20px;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  :global(.inputBox) {
    --tw-ring-color: #fff !important;
  }
</style>

<div class="drawer-content">
  <p data-cy="emulate-helper-text">Type in the user name you want to emulate or impersonate</p>

  <div class="my-4" data-cy="svelecte-wrapper" bind:this={svelecteWrapper} oninput={handleSvelecteInput}>
    <label for="username" class="mb-2">User Name</label>
    <Svelecte
      {fetchDebounceTime}
      options={emulateOptions}
      bind:value={selectedEmulateUser}
      clearable
      inputId="username"
      valueField="email"
      labelField="name"
      renderer="user-render"
      placeholder="Start typing a name"
      strictMode={false}
      valueAsObject
    />
  </div>

  <button
    type="button"
    disabled={!selectedEmulateUser}
    class="cursor-pointer text-white bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:outline-none font-normal rounded-md text-sm px-3 py-2 text-center inline-flex items-center me-2"
    data-cy="button-emulate-drawer"
    onclick={emulateAction}
  >
    <span class="whitespace-nowrap">Start Emulation</span>
    {#if isLoading}
      <span class="ml-2"><Loader size="4" /></span>
    {/if}
  </button>
</div>
